
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
import MenuSetKotGroup from "../menu/menu-set-kot-group.vue";
export default {
  components: { ResponsiveDialog, MenuSetKotGroup },
  props: {
    dialog: false,
    kotProp: {
      type: Object,
      default: () => {}
    }
  }
};
